export default defineAppConfig({
    toaster: {
        position: "bottom-center" as const,
        duration: 5000,
    },
    /* ui: {
        button: {
            slots: {
                base: "font-promedium bg-white text-black-text",
            },
        },
    }, */
})
